import { AbilityBuilder, Ability } from '@casl/ability'
import updateAbilities from './updateAbilities'
import store from '../stores/index'

const ability = new Ability(updateAbilities(store.getters['user/current']))

export default ability.rules
